import { StyleSheet } from 'aphrodite'

import row from './row'
import list from './list'
import status from './status'
import date from './date'
import ColorBlind from './ColorBlind'

export default {
  list: StyleSheet.create(list),
  row: StyleSheet.create(row),
  status: StyleSheet.create(status),
  date: StyleSheet.create(date),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Community/Main/partials/ApplicationTable/style/index.js